import { render } from "./prebook.vue?vue&type=template&id=5c001c96&scoped=true"
import script from "./prebook.vue?vue&type=script&lang=js"
export * from "./prebook.vue?vue&type=script&lang=js"

import "./prebook.vue?vue&type=style&index=0&id=5c001c96&scoped=true&lang=less"

import exportComponent from "D:\\work\\hongy-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c001c96"]])

export default __exports__